import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getBillingDetailsKey } from '../../utils/keys';
export const useBillingDetails = (options) => {
    const { useQueryOptions } = options || {};
    const { client } = useTribeClient();
    const billingDetailsKey = getBillingDetailsKey();
    return useQuery(billingDetailsKey, () => client.billing.details(), {
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useBillingDetails.js.map